/* eslint-disable react/react-in-jsx-scope */
import Text from '../../shared/textStyleDefault/texto'
import FadeInOnScroll from '../../shared/animations/fadeinonscroll'

const ItemLista = ({ data }: any): any => {
  return (
    <FadeInOnScroll>
      <div className="flex flex-col justify-center text-center px-0 md:px-[44px] py-0 md:py-[40px] h-[195px] md:h-[339px] max-w-[472px] border-[1px] border-[#FFE492] rounded-[10px] mb-[40px] md:mb-[0px]">
        {/* Ícono */}
        <div className="flex justify-center items-center h-auto w-[60px] mx-auto">
          <img src={data.icono} alt={`ícono de ${data.titulo}`} className="w-full h-auto" />
        </div>
        {/* Título */}
        <Text
          variant="beneficiosTitulo"
          className="text-center leading-tight my-[15px] md:my-[25px] whitespace-nowrap"
        >
          {data.titulo}
        </Text>

        {/* Texto */}
        <Text
          variant="casosSubtitulo"
          className="text-center font-normal leading-snug"
        >
          {data.texto}
        </Text>
      </div>
    </FadeInOnScroll>
  )
}

export default ItemLista
